// ForgotPassword.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API from '../api';
import TurnstileWidget from '../components/TurnstileWidget';
function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [turnstileToken, setTurnstileToken] = useState(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!turnstileToken) {
      setMessage("Veuillez compléter la vérification Turnstile.");
      return;
    }
    try {
      const response = await API.post(
        '/api/auth/reset-password',
        { email },
        {
          headers: { "X-Turnstile-Token": turnstileToken }
        }
      );
      setMessage(response.data.detail);
      setTimeout(() => navigate('/'), 3000);
    } catch (err) {
      setMessage(err.response?.data?.detail || "Erreur lors de la réinitialisation.");
    }
  };
  return (
    <div className="forgot-password-container">
      <h2>Réinitialisation du mot de passe</h2>
      {message && <p className="message">{message}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="email"
          placeholder="Votre email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
        />
        <div className="turnstile">
          <TurnstileWidget onVerify={setTurnstileToken} />
        </div>
        <button type="submit">Réinitialiser</button>
      </form>
    </div>
  );
}
export default ForgotPassword;
